module.exports = __webpack_public_path__ + "static/media/cidida-show.5e05b8a6.jpg";